import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { UserJobsDescriptionComponent } from '../user-jobs-description/user-jobs-description.component';
import { IUserJob } from 'app/scheduler/core/IUserJob';

@Component({
    selector: 'user-jobs-wrapper',
    templateUrl: 'user-jobs-wrapper.component.html',
    styleUrls: ['user-jobs-wrapper.component.scss']
})
export class UserJobsWrapperComponent implements OnChanges{

    @Input() userJobs: Array<IUserJob>;
    @Output() resetEmit = new EventEmitter();
    public currentUserJob: IUserJob;

    constructor() { }

    ngOnChanges() {
      if (this.currentUserJob) {
        for (let i = 0; i < this.userJobs.length; i++) {
          if(this.userJobs[i].guid === this.currentUserJob.guid) {
              this.currentUserJob = this.userJobs[i];
          }
        }
      }
    }

    setUserJob(userJob: IUserJob) {
        for (let i = 0; i < this.userJobs.length; i++) {
            if(this.userJobs[i].guid === userJob.guid) {
                this.userJobs[i] = userJob;
                this.currentUserJob = userJob;
            }
        }
    }

    reset () {
      this.resetEmit.emit();
    }

    setCurrentJob($event) {
      this.currentUserJob = $event;
    }
}
